require('./bootstrap/transition.js');
require('./bootstrap/collapse.js');
require('./bootstrap/dropdown.js');
require('./bootstrap/modal.js');
require('./bootstrap/tooltip.js');
require('./bootstrap/popover.js');
require('./bootstrap/tab.js');

require('./datatables/jquery.dataTables.min.js');
require('./datatables/jquery.dataTables.Bootstrap.min.js');

require('./source/jquery.adaptive-backgrounds.js');
require('./source/lib.js');
require('./source/main.js');
require('./source/modernizr.min.js');